import { render } from "./ExpressMV.vue?vue&type=template&id=1fca84c7&scoped=true"
import script from "./ExpressMV.vue?vue&type=script&lang=js"
export * from "./ExpressMV.vue?vue&type=script&lang=js"

import "./ExpressMV.vue?vue&type=style&index=0&id=1fca84c7&scoped=true&lang=css"
import "./ExpressMV.vue?vue&type=style&index=1&id=1fca84c7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fca84c7"]])

export default __exports__